import React from 'react';
import { Container, Button, Form, Alert } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper } from "../ContentStyles";
import useBackend, { SpinnerX } from '../../services/useBackend_v2';
import { Helmetx } from '../../services/misc';
import "./Contact.scss" 

export default function Contact() {
    const { loading, resultVariant, resultVisible, resultText, XCall, Update } = useBackend('');

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target), formDataObj = Object.fromEntries(formData.entries());
        //XCall('/backend/forms/contact', 'POST', 3000, { SystemID: "NS", FormData: formDataObj });
        Update({ SystemID: "NS", FormData: formDataObj }, 'POST', 3000, '/backend/forms/contact');        
    }

    return (
        <>
        <Helmetx />
        <ContentWrapper className="contact-page">
            <div className="contact-page__bg" aria-hidden="true">
                <div className="contact-page__blob contact-page__blob--a" />
                <div className="contact-page__blob contact-page__blob--b" />
            </div>
            <Container>
                <Sida className="contact-page__layout">
                    <div className="contact-card">
                        <Rubrik className="contact-card__title">
                            Kontakta oss eller boka demo
                        </Rubrik>
                        <Form onSubmit={handleSubmit} className="contact-form">
                            <Form.Group className="mb-3">
                                <Form.Control className="contact-input" type="text" name="Name" placeholder="Namn"
                                    disabled={resultVariant === "success" ? true : false}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control className="contact-input" type="email" name="Email" placeholder="Email"
                                    disabled={resultVariant === "success" ? true : false}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control className="contact-input" type="text" name="Subject" placeholder="Ämne"
                                    disabled={resultVariant === "success" ? true : false}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control className="contact-input contact-textarea" as="textarea" rows={6} name="Text" placeholder="Fråga"
                                 disabled={resultVariant === "success" ? true : false}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" hidden={!loading}>
                                <SpinnerX />
                            </Form.Group>

                            <Form.Group className="mb-3" hidden={!resultVisible}>
                                <Alert variant={resultVariant} className="contact-alert">{resultText}</Alert>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Button className="contact-submit" variant="primary" type="submit" disabled={resultVariant === "success" ? true : false}>Skicka</Button>
                            </Form.Group>
                        </Form>
                    </div>
                </Sida>
            </Container>
        </ContentWrapper>
        </>
    );
}